/**
 * Persists the profile language switch server-side (D22): `users.language`
 * drives email, notification and PDF language. Best-effort: the UI language
 * already changed locally, so a failed save must not surface as an error.
 */
export type ProfileLanguage = 'en' | 'tr';

export function toProfileLanguage(code: string): ProfileLanguage | null {
  const base = (code || '').toLowerCase().split('-')[0];
  return base === 'en' || base === 'tr' ? base : null;
}

export async function persistProfileLanguage(
  code: string,
  updateProfile: (data: { language: ProfileLanguage }) => Promise<unknown>,
): Promise<boolean> {
  const language = toProfileLanguage(code);
  if (!language) return false;
  try {
    await updateProfile({ language });
    return true;
  } catch {
    return false;
  }
}
